// Serbian (Latin script): the source copy of the site. en.js and ru.js use the same keys.
// Plurals: { one, few, many } + {count} (see translate() in index.js).
const sr = {
  common: {
    skip: "Preskoči na sadržaj",
    call: "Pozovite",
    callNow: "Pozovite odmah",
    callShort: "Pozovi",
    sendInquiry: "Pošaljite upit",
    sendInquiryShort: "Pošalji upit",
    allUnits: "Svi stanovi",
    seeUnits: "Pogledajte stanove",
    seeFreeUnits: "Pogledajte slobodne stanove",
    loading: "Učitavanje…",
    priceOnRequest: "Na upit",
    openMaps: "Otvorite u Google mapama",
    notRequired: "nije obavezno",
    close: "Zatvori",
    home: "Početna",
    backHome: "Nazad na početnu",
    company: "Tehnočin DOO Invest",
    city: "Beočin",
  },
  nav: {
    offer: "Ponuda",
    units: "Stanovi",
    process: "Kako gradimo",
    about: "O nama",
    location: "Lokacija",
    faq: "Pitanja",
    contact: "Kontakt",
    main: "Glavna navigacija",
    mobile: "Mobilna navigacija",
    footer: "Linkovi u podnožju",
    open: "Otvori meni",
    close: "Zatvori meni",
    logoHome: "Tehnočin DOO, početna",
  },
  lang: {
    label: "Jezik",
    switchTo: "Prikaži sajt na jeziku: {name}",
  },
  home: {
    hero: {
      eyebrow: "Novogradnja · Beočin",
      title: "Novi stanovi na Beočinskom trgu",
      lead: "Lamela A i Lamela B su stambeno-poslovne zgrade u centru Beočina. Mi smo porodična firma koja ih gradi, a stan kupujete direktno od nas.",
      art: "Piksel animacija: zgrada se gradi sprat po sprat uz kran",
    },
    facts: {
      label: "Ukratko o projektu",
      offer: "Ponuda",
      offerValue: { one: "{count} stan u 2 lamele", few: "{count} stana u 2 lamele", many: "{count} stanova u 2 lamele" },
      offerFallback: "2 lamele",
      free: "Slobodno",
      price: "Cena",
      priceFrom: "od {price}",
      address: "Adresa",
      addressValue: "Beočinski trg 2 i 4",
    },
    stats: {
      eyebrow: "Izgradili smo",
      title: "Šta smo izgradili",
      items: [
        { value: "90+", label: "izgrađenih stambenih jedinica" },
        { value: "4.000+", label: "kvadratnih metara" },
        { value: "30+", label: "zadovoljnih kupaca" },
        { value: "2", label: "stambeno-poslovna objekta" },
      ],
    },
    projects: {
      eyebrow: "Ponuda",
      title: "Izaberite lamelu",
      lead: "Pogledajte slobodne stanove u obe zgrade na Beočinskom trgu i izaberite raspored koji vam odgovara.",
    },
    featured: {
      eyebrow: "Slobodni stanovi",
      title: "Izdvajamo iz ponude",
    },
    process: {
      eyebrow: "Kako gradimo",
      title: "Od projekta do predaje stana",
      lead: "Naš tim vodi gradnju od temelja do predaje ključeva. Možete nas pitati šta se trenutno radi i dokle su radovi stigli.",
      steps: [
        { title: "Projekat i osnove", text: "Pre početka gradnje pripremamo osnove za svaki stan. Planiramo praktičan raspored i svetle prostorije." },
        { title: "Gradnja", text: "Naš tim i provereni majstori grade po savremenim standardima." },
        { title: "Nadzor na gradilištu", text: "Sami vodimo gradilište i pratimo rokove i kvalitet radova. Sa nama razgovarate direktno, bez podizvođača." },
        { title: "Predaja ključeva", text: "Ugovorom jasno dogovaramo cenu i uslove predaje stana." },
      ],
    },
    about: {
      eyebrow: "O nama",
      title: "Porodična firma koja gradi u Beočinu",
      lead: "Tehnočin je porodična građevinska firma iz Beočina. Gradimo sopstvenim timom i sa majstorima koje poznajemo. Sa svakim kupcem jasno dogovaramo uslove kupovine.",
      photoAlt: "Radnici Tehnočin DOO, snimljeni s leđa, ispred zgrade u izgradnji",
      values: [
        { title: "Decenije iskustva", text: "Decenijama radimo u građevini. Znamo kako da izgradimo kvalitetan stan koji traje." },
        { title: "Porodična firma", text: "Sa kupcima smo u kontaktu od prvog razgovora i obilaska do predaje ključeva." },
        { title: "Direktno od investitora", text: "Osnove, cene i uslove kupovine dobijate direktno od nas, bez posrednika." },
        { title: "Raspored i završni radovi", text: "Stanovi imaju praktičan raspored i svetle prostorije. Završne radove izvodimo pažljivo." },
      ],
    },
    reviews: {
      eyebrow: "Recenzije",
      title: "Šta kažu naši kupci",
      rating: "Ocena {value} od 5",
    },
    location: {
      eyebrow: "Lokacija",
      title: "U centru Beočina",
      lead: "Obe lamele su na Beočinskom trgu, u centru grada, blizu svakodnevnih sadržaja. Do Novog Sada i Fruške gore stižete kratkom vožnjom.",
      lamelaA: "Beočinski trg 4, Beočin",
      lamelaB: "Beočinski trg 2, Beočin",
      office: "Prodajna kancelarija",
      mapTitle: "Mapa: Beočinski trg, Beočin",
    },
    faq: {
      eyebrow: "Česta pitanja",
      title: "Pitanja o kupovini stana",
      items: [
        { q: "Gde se nalaze stanovi?", a: "Lamela A je na adresi Beočinski trg 4, a Lamela B na adresi Beočinski trg 2, u centru Beočina. Prodajna kancelarija je u Železničkoj 11a u Beočinu." },
        { q: "Koliko koštaju stanovi?", a: "Cene su od {price} i zavise od stana, sprata i rasporeda. Pošaljite upit za cenu i uslove kupovine stana koji vas zanima." },
        { q: "Da li kupujem direktno od investitora?", a: "Da. Mi smo investitor, Tehnočin DOO. Stan kupujete od nas, bez posrednika." },
        { q: "Koje strukture stanova su dostupne?", a: "U ponudi su stanovi od jednosobnih do petosobnih, kao i poslovni prostori (lokali) u prizemlju. U katalogu možete filtrirati stanove po strukturi, spratu i površini." },
        { q: "Mogu li da vidim stan pre kupovine?", a: "Da. Pozovite nas na {phone} da dogovorimo obilazak zgrade i stana u terminu koji vam odgovara." },
        { q: "Kako mogu da platim stan?", a: "Uslove plaćanja dogovaramo sa svakim kupcem. Pozovite nas ili pošaljite upit da razgovaramo o mogućnostima plaćanja." },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Zakažite obilazak ili zatražite ponudu",
      lead: "Pošaljite upit za osnove slobodnih stanova, cene i uslove kupovine. Možete nas i pozvati.",
      formTitle: "Pošaljite upit",
    },
    modalTitle: "Upit za stan",
  },
  catalogue: {
    title: "Stanovi na prodaju",
    titleProject: "{identifier} · {name}",
    breadcrumb: "Putanja",
    all: "Sve lamele",
    tabs: "Izbor lamele",
    address: "Beočinski trg 2 i 4, Beočin",
    filters: "Filteri",
    reset: "Poništi",
    resetFilters: "Poništi filtere",
    type: "Tip prostora",
    any: "Sve",
    structure: "Struktura",
    floor: "Sprat",
    allFloors: "Svi spratovi",
    area: "Površina",
    allAreas: "Sve površine",
    showSold: "Prikaži i prodate stanove",
    show: { one: "Prikaži {count} rezultat", few: "Prikaži {count} rezultata", many: "Prikaži {count} rezultata" },
    notFound: "Niste pronašli odgovarajući stan?",
    callUs: "Pozovite {phone}",
    results: { one: "{count} jedinica", few: "{count} jedinice", many: "{count} jedinica" },
    sort: "Sortiraj",
    sorts: { sprat: "Po spratu", "povrsina-rastuce": "Površina: manja → veća", "povrsina-opadajuce": "Površina: veća → manja" },
    areas: { "do-40": "do 40 m²", "40-60": "40 do 60 m²", "60-80": "60 do 80 m²", "80+": "80 m² i više" },
    emptyTitle: "Nema jedinica za izabrane filtere",
    emptyText: "Promenite filtere ili nas pozovite. Ponuda se redovno menja.",
    priceNote: "{identifier}: cene od {from}{to}. Za tačnu cenu stana i uslove plaćanja pošaljite upit.",
    priceTo: " do {price}",
    modalUnit: "Upit za stan",
    modalGeneral: "Pošaljite upit",
  },
  landing: {
    eyebrow: "Novogradnja · Beočinski trg",
    title: "Novi stanovi u centru Beočina",
    roomRange: "Od {from} do {to} stanova",
    roomRangeFallback: "Stanovi različitih struktura",
    priceFrom: "Cene od {price}",
    priceFallback: "Cene na upit, direktno od investitora",
    checkFree: "Proverite slobodne stanove",
    stillFree: "Još {label}",
    direct: "Kupujete direktno od investitora",
    callNow: "Pozovite odmah: {phone}",
    messengerText: "Zdravo, zanima me stan na Beočinskom trgu.",
    formTitle: "Pošaljite upit",
    formText: "Ostavite broj telefona i poslaćemo vam osnove slobodnih stanova i cene.",
    submit: "Pošaljite mi ponudu",
    messagePlaceholder: "Npr. tražim dvosoban stan na nižem spratu",
    reviewBy: "{author}, kupac",
    unitsEyebrow: "Slobodni stanovi",
    unitsTitle: "Stanovi u ponudi",
    prev: "Prethodni stanovi",
    next: "Sledeći stanovi",
    railLabel: "Lista slobodnih stanova",
    noUnits: "Pozovite nas za aktuelnu ponudu stanova.",
    fullCatalogue: "Pogledajte sve stanove",
    locationTitle: "Beočinski trg, Beočin",
    locationText: "Lamela A (Beočinski trg 4) i Lamela B (Beočinski trg 2) su u centru Beočina, blizu Novog Sada i Fruške gore.",
    office: "Prodajna kancelarija: {office}",
    schedule: "Zakažite obilazak",
  },
  thanks: {
    title: "Hvala, primili smo vaš upit!",
    text: "Uskoro ćemo vam se javiti sa osnovama slobodnih stanova i cenama. Ako vam je hitno, pozovite nas.",
    see: "Pogledajte sve stanove",
  },
  notFound: {
    title: "Stranica nije pronađena",
    text: "Link je možda zastareo ili pogrešno ukucan. Pogledajte ponudu stanova ili se vratite na početnu stranu.",
    home: "Početna strana",
  },
  form: {
    unitFor: "Upit za:",
    interest: "Šta vas zanima?",
    interestOptions: { Jednosoban: "Jednosoban", Dvosoban: "Dvosoban", "Trosoban i veći": "Trosoban i veći", Lokal: "Lokal" },
    name: "Ime i prezime",
    phone: "Telefon",
    phonePlaceholder: "06x xxx xxxx",
    email: "E-mail",
    message: "Poruka",
    messagePlaceholder: "Koji stan vas zanima, kada planirate kupovinu…",
    honeypot: "Vaš sajt",
    errors: {
      name: "Unesite ime i prezime.",
      phone: "Unesite ispravan broj telefona.",
      email: "E-mail adresa nije ispravna.",
      message: "Napišite kratku poruku.",
    },
    sending: "Šaljem…",
    submit: "Pošaljite upit",
    sentTitle: "Hvala, upit je poslat!",
    sentText: "Javićemo vam se što pre.",
    failed: "Slanje nije uspelo. Pokušajte ponovo ili nas pozovite na",
    privacy: "Vaše podatke koristimo samo da bismo odgovorili na upit.",
  },
  unit: {
    status: { slobodan: "Slobodan", rezervisan: "Rezervisan", prodat: "Prodat" },
    types: { stan: "Stan", lokal: "Lokal", garaža: "Garažno mesto" },
    struktura: {
      "0.5": "Garsonjera",
      "1": "Jednosoban",
      "1.5": "Jednoiposoban",
      "2": "Dvosoban",
      "2.5": "Dvoiposoban",
      "3": "Trosoban",
      "3.5": "Troiposoban",
      "4": "Četvorosoban",
      "5": "Petosoban",
    },
    rooms: "{count} sobe",
    // Genitive plural, used in "Od jednosobnih do trosobnih stanova"
    strukturaPlural: {
      "0.5": "garsonjera",
      "1": "jednosobnih",
      "1.5": "jednoiposobnih",
      "2": "dvosobnih",
      "2.5": "dvoiposobnih",
      "3": "trosobnih",
      "3.5": "troiposobnih",
      "4": "četvorosobnih",
      "5": "petosobnih",
    },
    floors: { "-1": "Suteren", "0": "Prizemlje", n: "{roman} sprat", attic: "Potkrovlje", atticOf: "Potkrovlje ({floor})" },
    floorNumeric: "{n}. sprat",
    priceOnRequest: "Cena na upit",
    viewPlan: "Pogledaj osnovu: {title}",
    planSoon: "{title}: osnova uskoro",
    planAlt: "Osnova: {title}",
    planPlaceholder: "Osnova uskoro",
    sold: "Prodato",
    inquire: "Pošalji upit",
  },
  project: {
    freeFlats: { one: "{count} slobodan stan", few: "{count} slobodna stana", many: "{count} slobodnih stanova" },
    freeShops: { one: "{count} slobodan lokal", few: "{count} slobodna lokala", many: "{count} slobodnih lokala" },
    soldPct: "{pct}% prodato",
    soldAria: "Prodato {pct}% stanova",
    price: "Cena",
    shops: "Lokali",
    soldOut: "Prodato",
    floors: "Spratnost",
    floorsValue: "{count} spratova",
    photosSoon: "Fotografije uskoro",
    seeUnits: "Pogledajte stanove",
  },
  footer: {
    tagline: "Porodična građevinska firma iz Beočina. Stanove kupujete direktno od nas.",
    site: "Sajt",
    contact: "Kontakt",
    follow: "Pratite nas",
    office: "Kancelarija: {office}",
    rights: "Sva prava zadržana.",
  },
  gallery: {
    label: "Galerija",
    close: "Zatvori galeriju",
    prev: "Prethodna fotografija",
    next: "Sledeća fotografija",
    photo: "Fotografija",
    of: "{n} od {total}",
    enlarge: "Uvećaj fotografiju: {alt}",
  },
  seo: {
    siteName: "Tehnočin DOO",
    home: {
      title: "Novi stanovi u Beočinu, Beočinski trg | Tehnočin DOO",
      description: "Novi stanovi na Beočinskom trgu u Beočinu, Lamela A i Lamela B. Slobodni stanovi, osnove i cene od 1.200 €/m², direktno od investitora Tehnočin DOO.",
    },
    catalogue: {
      title: "Stanovi na prodaju u Beočinu, katalog | Tehnočin",
      description: "Svi slobodni stanovi i lokali na Beočinskom trgu u Beočinu. Filtrirajte po strukturi, spratu i površini, pogledajte osnove i pošaljite upit.",
    },
    catalogueProject: {
      title: "{identifier}: stanovi na prodaju, Beočin | Tehnočin",
      description: "{identifier}, {address}: slobodni stanovi, osnove i cene. Novogradnja u centru Beočina, direktno od investitora Tehnočin DOO.",
    },
    landing: {
      title: "Novi stanovi u centru Beočina | Tehnočin",
      description: "Stanovi od jednosobnih do petosobnih na Beočinskom trgu. Ostavite broj i poslaćemo vam osnove i cene slobodnih stanova.",
    },
    thanks: { title: "Hvala na upitu | Tehnočin DOO", description: "Vaš upit je primljen." },
    notFound: { title: "Stranica nije pronađena | Tehnočin DOO", description: "Tražena stranica ne postoji. Pogledajte ponudu novih stanova na Beočinskom trgu ili se vratite na početnu." },
    breadcrumbHome: "Početna",
    breadcrumbUnits: "Stanovi",
  },
};

export default sr;
